import React from "react";
import { Container } from "../components/styled.ts";
import { Typography } from "../components/typography/index.tsx";
import { Header } from "../components/header/index.tsx";
import { Seo } from "../components/seo/index.tsx";
import { useMobile } from "../hooks/isMobile.tsx";

const Disclaimer = () => {
    const { isMobile } = useMobile();
    return (
        <>
            <Seo
                title="Disclaimer | FinQ India"
                description="FinQ India alerts are for informational purposes only and are not financial or investment advice. Read our full disclaimer on data accuracy and usage."
                path="/disclaimer"
            />
            <Header />
            <Container
                width="min(calc(100% - 40px) , 900px)"
                justifyContent="center"
                margin="20px auto"
                column
                gap={"20px"}
            >
                <Typography
                    tag="h1"
                    fontFamily="Neue Montreal"
                    fontSize={"28px"}
                    fontWeight={500}
                    lineHeight={"36.4px"}
                    letterSpacing={"0.02em"}
                    color="#202020"
                >
                    Disclaimer - FinQ India (finq.in)
                </Typography>

                <Typography
                    tag="p"
                    fontFamily="Neue Montreal"
                    fontSize={"18px"}
                    fontWeight={400}
                    lineHeight={"27px"}
                    letterSpacing={"0.02em"}
                    color="#828282"
                >
                    The information provided on <span style={{ fontWeight: 500, color: "#202020" }}>FinQ India (finq.in)</span> is for informational purposes only and should not be considered financial or investment advice. We do not guarantee the accuracy, completeness, or reliability of any information presented.
                </Typography>

                <Typography
                    tag="p"
                    fontFamily="Neue Montreal"
                    fontSize={"18px"}
                    fontWeight={400}
                    lineHeight={"27px"}
                    letterSpacing={"0.02em"}
                    color="#828282"
                >
                    Market summaries and stock insights on this platform are generated using AI algorithms and may be subject to errors. Users are advised to verify information from official sources before making any financial decisions.
                </Typography>

                <Typography
                    tag="p"
                    fontFamily="Neue Montreal"
                    fontSize={"18px"}
                    fontWeight={400}
                    lineHeight={"27px"}
                    letterSpacing={"0.02em"}
                    color="#828282"
                >
                    We may offer limited features, such as free tracking of selected stocks, which are subject to change or discontinuation at our discretion without prior notice.
                </Typography>

                <Typography
                    tag="p"
                    fontFamily="Neue Montreal"
                    fontSize={"18px"}
                    fontWeight={400}
                    lineHeight={"27px"}
                    letterSpacing={"0.02em"}
                    color="#828282"
                >
                    <span style={{ fontWeight: 500, color: "#202020" }}>FinQ India (finq.in)</span>, its owners, and affiliates shall not be held responsible for any losses or damages resulting from the use of the information provided on this platform.
                </Typography>

                <Typography
                    tag="p"
                    fontFamily="Neue Montreal"
                    fontSize={"18px"}
                    fontWeight={400}
                    lineHeight={"27px"}
                    letterSpacing={"0.02em"}
                    color="#828282"
                >
                    By using this website, you agree to this disclaimer and acknowledge the risks associated with financial markets.
                </Typography>

                <Typography
                    tag="p"
                    fontFamily="Neue Montreal"
                    fontSize={"18px"}
                    fontWeight={400}
                    lineHeight={"27px"}
                    letterSpacing={"0.02em"}
                    color="#828282"
                >
                    <span style={{ fontWeight: 500, color: "#202020" }}>FinQ India (finq.in)</span> is owned and operated by KONSRI TECHNOLOGIES PRIVATE LIMITED.
                </Typography>
            </Container>
        </>
    );
};

export default Disclaimer;
